// extracted by mini-css-extract-plugin
export default {"loader__image":"loader__image-v7CqO","loader__message":"loader__message-TplNz"};